/* istanbul ignore file */

export var getRect = function getRect(el, property) {
  var _el$getBoundingClient;
  return (_el$getBoundingClient = el === null || el === void 0 ? void 0 : el.getBoundingClientRect()[property]) !== null && _el$getBoundingClient !== void 0 ? _el$getBoundingClient : 0;
};
export var getPagePosition = function getPagePosition(el) {
  return (window.pageYOffset || document.documentElement.scrollTop) + getRect(el, 'top');
};